import React, { useEffect, useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import "./MainNav.css";
import whiteLogo from "../../asset/Image/logo2.png";
import blackLogo from "../../asset/Image/logo1.png";
import { NavLink } from "react-router-dom";

export default function MainNav(props) {
  const [scroll, setScroll] = useState({
    navBarTitle: "top-logo",
    navBarLogo: [whiteLogo],
    navBackground: "top-menu-nav",
    navItemMenu: "navItem",
    navMobileIcon: "hembergMenu",
    navHamberg: "dark",
    pageTitle: props.title,
    width: "top-menu-width ",
  });
  const onScroll = () => {
    if (window.scrollY > 100) {
      setScroll({
        navBarTitle: "top-logoScroll",
        navBarLogo: [blackLogo],
        navBackground: "top-menu-navScroll",
        navItemMenu: "navItemScroll",
        navHamberg: "light",
      });
    } else if (window.screenY < 100) {
      setScroll({
        navBarTitle: "top-logo",
        navBarLogo: [whiteLogo],
        navBackground: "top-menu-nav",
        navItemMenu: "navItem",
        navHamberg: "dark",
      });
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", onScroll);
  }, []);
  return (
    <>
      <title>{scroll.pageTitle}</title>
      <Navbar
        className={`${scroll.navBackground} `}
        fixed="top"
        expand="lg"
        variant={scroll.navHamberg}
      >
        <Container>
          <Navbar.Brand className={`${scroll.navBarTitle} text-uppercase`}>
            <NavLink to="/">
              {" "}
              <img src={scroll.navBarLogo} alt="" />
            </NavLink>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            className={`${scroll.navMobileIcon}`}
          />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto"></Nav>
            <Nav>
              <Nav.Link>
                <NavLink
                  to="/"
                  style={({ isActive }) =>
                    isActive
                      ? {
                          color: "#ebab34",
                        }
                      : { color: "#fff" }
                  }
                  className={`${scroll.navItemMenu}`}
                >
                  Home
                </NavLink>
              </Nav.Link>
              <Nav.Link>
                <NavLink
                  to="/about"
                  style={({ isActive }) =>
                    isActive
                      ? {
                          color: "#ebab34",
                        }
                      : { color: "#fff" }
                  }
                  className={`${scroll.navItemMenu}`}
                >
                  About
                </NavLink>
              </Nav.Link>
              <Nav.Link>
                <NavLink
                  to="/services"
                  style={({ isActive }) =>
                    isActive
                      ? {
                          color: "#ebab34",
                        }
                      : { color: "#fff" }
                  }
                  className={`${scroll.navItemMenu}`}
                >
                  Service
                </NavLink>
              </Nav.Link>
              <Nav.Link>
                <NavLink
                  to="/courses"
                  style={({ isActive }) =>
                    isActive
                      ? {
                          color: "#ebab34",
                        }
                      : { color: "#fff" }
                  }
                  className={`${scroll.navItemMenu}`}
                >
                  Courses
                </NavLink>
              </Nav.Link>
              <Nav.Link>
                <NavLink
                  to="/projects"
                  style={({ isActive }) =>
                    isActive
                      ? {
                          color: "#ebab34",
                        }
                      : { color: "#fff" }
                  }
                  className={`${scroll.navItemMenu}`}
                >
                  Portfolio
                </NavLink>
              </Nav.Link>
              <Nav.Link>
                <NavLink
                  to="/contact"
                  style={({ isActive }) =>
                    isActive
                      ? {
                          color: "#ebab34",
                        }
                      : { color: "#fff" }
                  }
                  className={`${scroll.navItemMenu}`}
                >
                  Contact Us
                </NavLink>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}
